<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div class="row">
              <div class="col-6 text-left">
                <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon>Go Back</a>
              </div>
              <div class="col-6 text-right">
                <button :class="{'btn':true, 'btn-primary':saveTracker===true, 'btn-secondary':saveTracker===false, 'btn-short':true}" @click="doSave">Save</button>
              </div>
            </div>
            <div class="row mt-2" v-if="ldata!==null">
              <div class="col-8 p1 borderright">
                <div class="row">
                  <div class="field col-12">
                    <label class="text-dark">Lesson Name</label><br />
                    <input class="mb-0 fullWidth" type="text" aria-label="Enter lesson name here" v-model.trim="ldata.CourseName" @change="setSaveTracker">
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="field col-12">
                    <label class="text-dark">Lesson Type</label> <button class="btn-transparent ib" @click="doCurriculumHelp(7)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                    <select v-model="ldata.CourseType" @change="setSaveTracker" class="fullWidth">
                      <option value="0">Simulation</option>
                      <option value="1">E-Learning</option>
                      <option value="2">Questionnaire</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="field col-12">
                    <label class="text-dark">Lesson Description</label><br />
                    <input class="mb-0 fullWidth" type="text" aria-label="Enter short description here" @change="setSaveTracker" v-model.trim="ldata.LessonDescription">
                  </div>
                </div>
                <div class="row mt-3" v-show="ldata.CourseType!==1">
                  <div class="field col-12">
                    <label class="text-dark">Completion Criteria</label><br />
                    <div class="row">
                      <div class="col-9">
                        <div class="row mt-1" v-for="cc in allcc.filter(p=>p.IsRemoved===false)" v-if="allcc.length">
                          <div class="col-1">
                            <button class="btn-transparent" @click="doEditCompletionCriteria(cc.LicensePoolCurriculaCourseCompID)"><font-awesome-icon icon="edit" aria-label="Edit completion criterion"></font-awesome-icon></button>
                          </div>
                          <div class="col-1">
                            <button class="btn-transparent" @click="doRemoveCompletionCriteria(cc.LicensePoolCurriculaCourseCompID)"><font-awesome-icon icon="times" aria-label="Delete completion criterion"></font-awesome-icon></button>
                          </div>
                          <div class="col-10">
                            Can complete with {{cc.NumberOfCompletions}} pass(es) at a score of {{cc.PassingScore}} or higher
                          </div>
                        </div>
                        <div class="row mt-1" v-if="allcc.filter(p=>p.IsRemoved===false).length===0">
                          <div class="col-12">
                            There are no completion criteria (members will complete lesson automatically)
                          </div>
                        </div>
                      </div>
                      <div class="col-3 text-right">
                        <button class="btn btn-secondary btn-short" @click="doAddCompletionCriteria">Add</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="field col-12">
                    <label class="text-dark">Play Forever</label> <button class="btn-transparent ib" @click="doCurriculumHelp(10)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                    <input type="checkbox" class="checkbox" v-model="ldata.PlayInfinitely" @change="setSaveTracker" /> Student Can Play Lesson Forever
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="field col-12">
                    <label class="text-dark">Lesson Instructions</label> <button class="btn-transparent ib" @click="doCurriculumHelp(15)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                    <ckeditor :editor="aeditor" v-model="ldata.CourseInstructions" @change="setSaveTracker" :config="editorConfig"></ckeditor>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="field col-12">
                    <label class="text-dark">Lesson Completed Text</label> <button class="btn-transparent ib" @click="doCurriculumHelp(16)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                    <ckeditor :editor="beditor" v-model="ldata.CoursePassedText" @change="setSaveTracker" :config="editorConfig"></ckeditor>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="field col-12">
                    <label class="text-dark">Lesson Not-Completed Text</label> <button class="btn-transparent ib" @click="doCurriculumHelp(17)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                    <ckeditor :editor="ceditor" v-model="ldata.CourseFailedText" @change="setSaveTracker" :config="editorConfig"></ckeditor>
                  </div>
                </div>
              </div>
              <div class="col-4 p1">
                <div v-show="ldata.CourseType==2">
                  <div class="row">
                    <div class="col-12">
                      <label class="text-dark">Questionnaire</label><br />
                      <select v-model="ldata.CourseProductID" class="fullWidth" @change="setSaveTracker">
                        <option v-for="q in Questionnaires" v-bind:value="q.QuestionnaireID">{{q.Name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div v-show="ldata.CourseType==1">

                  <div class="row mt-4 borders ml-1">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12">
                          <label class="text-dark">Product</label><br />
                          <select v-model="ldata.CourseProductID" class="fullWidth">
                            <option v-for="pr in Products" v-bind:value="pr.ProductID">{{pr.ProductName}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-12">
                          <label class="text-dark">Options</label>
                          <hr />
                          Required Minutes <button class="btn-transparent ib" @click="doCurriculumHelp(13)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                          <input v-model="ldata.CourseTime" class="fullWidth" @change="setSaveTracker"><br />
                          Enable Clock <button class="btn-transparent ib" @click="doCurriculumHelp(39)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button>
                          <input type="checkbox" @change="setSaveTracker" v-model="ldata.EnableClock">
                        </div>
                      </div>
                     
                    </div>
                  </div>
                </div>
                <div v-show="ldata.CourseType==0">
                  <div class="row">
                    <div class="col-12">
                      <label class="text-dark">Product</label><br />
                      <select v-model="ldata.CourseProductID" class="fullWidth" @change="fillCharactersLOPs(true)">
                        <option v-for="pr in Products" v-bind:value="pr.ProductID">{{pr.ProductName}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row mt-4 borders ml-1">
                    <div class="col-12">
                      <label class="text-dark">Options</label>
                      <hr />
                      <input type="checkbox" class="checkbox" v-model="ldata.CanPractice" @change="setSaveTracker"> Student can use product outside of lesson <button class="btn-transparent ib" @click="doCurriculumHelp(8)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                      <input type="checkbox" class="checkbox" v-model="ldata.StudentCanRestart" @change="setSaveTracker"> Student will restart lesson (instead of resuming) <button class="btn-transparent ib" @click="doCurriculumHelp(9)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                      Time Limit (minutes): <input type="text" v-model="ldata.TimeLimit" @change="setSaveTracker" class="fullWidth">
                    </div>
                  </div>
                  <div class="row mt-4 borders ml-1">
                    <div class="col-12">
                      <label class="text-dark">Simulation Playback Settings</label>
                      <hr />
                      <input v-model="ldata.AllowAVSkipping" @change="setSaveTracker" type="checkbox" class="checkbox"> Allow A/V Skipping <button class="btn-transparent ib" @click="doCurriculumHelp(18)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <input v-model="ldata.AllowResume" @change="setSaveTracker" type="checkbox" class="checkbox"> Allow Color Coding <button class="btn-transparent ib" @click="doCurriculumHelp(19)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <input v-model="ldata.HighlightFollowOns" @change="setSaveTracker" type="checkbox" class="checkbox"> Highlight Followons <button class="btn-transparent ib" @click="doCurriculumHelp(20)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <input v-model="ldata.AllowOptions" @change="setSaveTracker" type="checkbox" class="checkbox"> Allow Options <button class="btn-transparent ib" @click="doCurriculumHelp(21)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <input v-model="ldata.AllowToolTips" @change="setSaveTracker" type="checkbox" class="checkbox"> Allow Tool Tips <button class="btn-transparent ib" @click="doCurriculumHelp(22)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <input v-model="ldata.AllowScoreReview" @change="setSaveTracker" type="checkbox" class="checkbox"> Allow Score Review <button class="btn-transparent ib" @click="doCurriculumHelp(23)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <span v-show="limitlops.length===0"><input @change="setSaveTracker" v-model="ldata.AllowIntroScreens" type="checkbox" class="checkbox"> Allow Intro Screens <button class="btn-transparent ib" @click="doCurriculumHelp(24)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br></span>

                      <input v-model="ldata.ShowFeedbackText" @change="setSaveTracker" type="checkbox" class="checkbox"> Show Last Turn And Feedback Text <button class="btn-transparent ib" @click="doCurriculumHelp(26)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <input v-model="ldata.ShowFeedbackBar" @change="setSaveTracker" type="checkbox" class="checkbox"> Show Feedback Bar <button class="btn-transparent ib" @click="doCurriculumHelp(27)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <input v-model="ldata.ShowHelpAgent" @change="setSaveTracker" type="checkbox" class="checkbox"> Show Help Agent <button class="btn-transparent ib" @click="doCurriculumHelp(28)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <input v-model="ldata.AllowRestart" @change="setSaveTracker" type="checkbox" class="checkbox"> Allow Restart <button class="btn-transparent ib" @click="doCurriculumHelp(29)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <input v-model="ldata.AllowTranscript" type="checkbox" class="checkbox" @change="doAllowTranscript"> Allow Transcript <button class="btn-transparent ib" @click="doCurriculumHelp(30)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <span v-show="ldata.AllowTranscript===true">&nbsp;&nbsp;&nbsp;&nbsp;<input v-model="ldata.AllowRewind" @change="setSaveTracker" type="checkbox" class="checkbox"> Allow Rewind <button class="btn-transparent ib" @click="doCurriculumHelp(31)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br></span>

                      Statement View Type <button class="btn-transparent ib" @click="doCurriculumHelp(25)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <select v-model="ldata.StatementViewType" class="fullWidth" @change="setSaveTracker"><option value="0">Default</option><option value="1">Topic View</option><option value="2">List View</option></select><br />

                      Prompts <button class="btn-transparent ib" @click="doCurriculumHelp(40)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br>
                      <select v-model="ldata.OffPromptMode" class="fullWidth" @change="setSaveTracker"><option value="0">Default</option><option value="1">Force Prompted Mode</option><option value="2">Force Off-Prompt Mode</option></select><br />

                      <input v-model="ldata.OffPromptSuggestions" @change="setSaveTracker" type="checkbox" class="checkbox"> Allow Suggestions in Off-Prompt Mode <button class="btn-transparent ib" @click="doCurriculumHelp(41)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button>
                    </div>
                  </div>
                  <div class="row mt-4 borders ml-1" v-show="limitcharacters.length>0">
                    <div class="col-12">
                      <label class="text-dark">Allow Characters</label> <button class="btn-transparent ib" @click="doCurriculumHelp(33)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button>
                      <hr />
                      <div v-for="char in limitcharacters">
                        <input type="checkbox" class="checkbox" @change="setSaveTracker" v-model="char.IsSelected" /> {{char.CharacterName}}
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4 borders ml-1" v-show="limitlops.length>0">
                    <div class="col-12">
                      <label class="text-dark">Allow Levels of Play</label> <button class="btn-transparent ib" @click="doCurriculumHelp(32)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button>
                      <hr />
                      <div v-for="lop in limitlops">
                        <input type="checkbox" class="checkbox" @change="setSaveTracker" v-model="lop.IsSelected" /> {{lop.LOPAvailable}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12 text-right">
                    <button :class="{'btn':true, 'btn-primary':saveTracker===true, 'btn-secondary':saveTracker===false, 'btn-short':true}" @click="doSave">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal title="Add/Edit Completion Criteria" ref="compCriteriaModal" size="lg" @ok="doAECompletionCriteria">
      <div v-if="thiscc!==null">
        <div class="row">
          <div class="col-12">
            A required score of 0 automatically passes
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-8">
            Number of Passes Required:
          </div>
          <div class="col-4">
            <input type="number" v-model.trim="thiscc.NumberOfCompletions" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-8">
            Score Required to Pass:
          </div>
          <div class="col-4">
            <input type="number" v-model.trim="thiscc.PassingScore" />
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal ref="tpModal" ok-only title="Training Plan Help">
      <div v-html="helpcontent">
      </div>
    </b-modal>
    <acfooter></acfooter>
  </div>
</template>

<style scoped>
   .borders {
      border:1px solid #666;
      border-radius:10px;
      padding:3% 1%;
   }
   .borderright {
      border-right:1px solid #666;
   }
   hr {
      margin:0!important;
   }
</style>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

  export default {
    name: "EditLesson",
    components: {acheader,acfooter,clientsidebar},
    data() {
      return {
         allcc:[],
         aeditor:ClassicEditor,
         beditor:ClassicEditor,
         ceditor:ClassicEditor,
         editorConfig: {
           toolbar: {
             items: [
               'heading',
               '|',
               'bold',
               'italic',
               '|',
               'bulletedList',
               'numberedList',
               'blockQuote',
               '|',
               'link',
               '|',
               'insertTable',
               '|',
               'undo',
               'redo'
             ]
           },
           table: {
             contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
           },
           language: 'en'
         },
         helpcontent: null,
         ldata:null,
         limitcharacters:[],
         limitlops:[],
         thiscc:null,
         Products:[],
         Questionnaires:[],
         saveTracker:false
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.saveTracker===true) {
        if (window.confirm("Are you sure you wish to leave this page? Changes you have made will not be saved")) {
          next();
        }
        else {
          next(false);
        }
      }
      else {
        next();
      }
    },
    methods: {
      doAddCompletionCriteria() {
        this.saveTracker=true;
        this.thiscc= {
          IsAdded:true,
          IsEdited:false,
          IsRemoved:false,
          NumberOfCompletions:0,
          PassingScore:0,
          LicensePoolCurriculaCourseCompID: new Date().getTime()
        };
        this.$refs["compCriteriaModal"].show();
      },
      doAECompletionCriteria() {
        if (this.thiscc.IsAdded===true) {
          if (this.allcc.filter(p=>p.LicensePoolCurriculaCourseCompID===this.thiscc.LicensePoolCurriculaCourseCompID).length===0) { 
            this.allcc.push(this.thiscc);
          }
        }
        else {
          var cc = this.allcc.filter(p=>p.LicensePoolCurriculaCourseCompID===this.thiscc.LicensePoolCurriculaCourseCompID);
          console.log(cc);
          if (cc.length>0) {
            cc[0].IsEdited=true;
          }
        }
        this.thiscc=null;
      },
      doAllowTranscript() {
        this.saveTracker=true;
        if (this.ldata.AllowTranscript===false) {
          this.ldata.AllowRewind=false;
        }
      },
      doEditCompletionCriteria(ccid) {
        for(var cc of this.allcc.filter(p=>p.LicensePoolCurriculaCourseCompID===ccid)) {
           this.thiscc=cc;
        }
        if (this.thiscc!==null) {
           this.$refs["compCriteriaModal"].show();
        } 
      },
      doRemoveCompletionCriteria(ccid) {
        for(var x=0; x<this.allcc.length; x++) {
          if (this.allcc[x].LicensePoolCurriculaCourseCompID===ccid) {
            this.allcc[x].IsRemoved=true;
            this.allcc[x].IsAdded=false;
          }
        }
        this.$forceUpdate();
      },
      doSave() {

     
        var courseProduct = ""; 
        if (this.ldata.CourseType<2) {
          if (this.ldata.CourseProductID===null || this.ldata.CourseProductID===this.emptyguid) {
            this.popDialog(1, "You must select a product");
            return;
          }
          courseProduct=this.ldata.CourseProductID;
        }
        if (this.ldata.CourseType==2) {
          if (this.ldata.CourseProductID===null || this.ldata.CourseProductID===this.emptyguid) {
            this.popDialog(1, "You must select a questionnaire");
            return;
          }
          courseProduct=this.ldata.CourseProductID;
        }

        if (this.ldata.CourseName.length ===0)
        {
          this.popDialog(1,"The lesson name field cannot be blank");
          return;
        }

        if (this.limitlops.length>0) {
          this.ldata.AllowIntroScreens=true;
        }

        var commands = [
            {
              Operation: "LicensePool",
              Function: "AddCurriculumCourse",
              Fields: {
                LicensePoolCurriculaID: this.$route.params.tpid,
                CourseProductID: courseProduct,
                PlayInfinitely: this.ldata.PlayInfinitely?"true":"false",
                CourseName: this.ldata.CourseName,
                ShowFeedbackText: this.ldata.ShowFeedbackText ? "true" : "false",
                ShowFeedbackBar: this.ldata.ShowFeedbackBar ? "true" : "false",
                ShowHelpAgent: this.ldata.ShowHelpAgent ? "true" : "false",
                AllowOptions: this.ldata.AllowOptions ? "true" : "false",
                AllowRewind: this.ldata.AllowRewind ? "true" : "false",
                AllowRestart: this.ldata.AllowRestart ? "true" : "false",
                AllowIntroScreens: this.ldata.AllowIntroScreens ? "true" : "false",
                AllowSaveLoad: "false",
                AllowResume: this.ldata.AllowResume ? "true" : "false",
                AllowTranscript: this.ldata.AllowTranscript ? "true" : "false",
                AllowAVSkipping: this.ldata.AllowAVSkipping ? "true" : "false",
                AllowScoreReview: this.ldata.AllowScoreReview ? "true" : "false",
                AllowTooltips: this.ldata.AllowToolTips ? "true": "false",
                HighlightFollowons: this.ldata.HighlightFollowOns ? "true" : "false",
                AllowTooltips: this.ldata.AllowToolTips ? "true" : "false",
                StatementViewType: this.ldata.StatementViewType,
                CoursePassedText: this.ldata.CoursePassedText,
                CourseFailedText: this.ldata.CourseFailedText,
                CourseInstructions: this.ldata.CourseInstructions,
                AltProductName: "",
                AltProductDescription: "",
                CanPractice: this.ldata.CanPractice ? "true" : "false",
                CourseType:this.ldata.CourseType,
                CourseTime: this.ldata.CourseTime,
                StudentCanRestart: this.ldata.StudentCanRestart ? "true" : "false",
                LessonDescription: this.ldata.LessonDescription,
                EnableClock: this.ldata.EnableClock ? "true" : "false",
                TimeLimit: this.ldata.TimeLimit,
                OffPromptMode: this.ldata.OffPromptMode,
                OffPromptSuggestions: this.ldata.OffPromptSuggestions
              }
            }
        ];

        if (this.$route.params.lid!==this.emptyguid)
        {
          commands[0].Function = "EditCurriculumCourse";
          commands[0].Fields.LicensePoolCurriculaCourseID = this.$route.params.lid;
          commands[0].Fields.CourseNumber = this.ldata.CourseNumber;
        }

    
        this.apiCommand(commands).then(r=> {

          this.saveTracker=false;
          var cr = JSON.parse(r.CommandResult);

          var CourseID=null;
          if (this.$route.params.lid===this.emptyguid) {
            CourseID=cr.returnObjects[0].returnObject;
            if (CourseID.length !== 36) {
              this.popDialog(1, CourseID);
              return;
            }
          }
          else {
            CourseID=this.$route.params.lid;
          }
       
          if (this.ldata.CourseType!==1) {
            var ccops = [];

            for (var lcc of this.allcc) {

              if (lcc.IsAdded) {
                ccops.push({
                  Operation: "LicensePool",
                  Function: "AddCurriculumCourseCompletionCriteria",
                  Fields: {
                    CourseID: CourseID,
                    CurriculumID: this.$route.params.tpid,
                    NumCompletions: lcc.NumberOfCompletions,
                    PassingScore: lcc.PassingScore
                  }
                });
              }
              if (lcc.IsEdited) {
                ccops.push({
                  Operation: "LicensePool",
                  Function: "EditCurriculumCourseCompletionCriteria",
                  Fields: {
                    CompID: lcc.LicensePoolCurriculaCourseCompID,
                    CourseID: CourseID,
                    CurriculumID: this.$route.params.tpid,
                    NumCompletions: lcc.NumberOfCompletions,
                    PassingScore: lcc.PassingScore
                  }
                });
              }
              if (lcc.IsRemoved) {
                ccops.push({
                  Operation: "LicensePool",
                  Function: "DeleteCurriculumCourseCompletionCriteria",
                  Fields: {
                    CompID: lcc.LicensePoolCurriculaCourseCompID,
                    CourseID: CourseID,
                    CurriculumID: this.$route.params.tpid,
                  }
                });
              }
            }

            if (ccops.length > 0) {
              this.apiCommand(ccops);
            }
          }

          var restrictChars=[];
          var restrictLOPs=[];

          for(var lop of this.limitlops) {
            if (!lop.IsSelected) {
              restrictLOPs.push(lop.LOPAvailable);
            }
          }

          for(var chr of this.limitcharacters) {
            if (!chr.IsSelected) {
              restrictChars.push(chr.CharacterNum);
            }
          }

          this.apiCommand([
            {
              Operation: "LicensePool",
              Function: "EditRestrictedChars",
              Fields: {
                CourseID: CourseID,
                restrictedChars: restrictChars
              }
            }
          ]);
         
          this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "EditRestrictedLOPs",
            Fields: {
              CourseID: CourseID,
              restrictedLOPs: restrictLOPs
            }
          }
          ])

          this.popDialog(0, "Lesson edited successfully");
          this.$router.push("/trainingplans/"+this.$route.params.tpid+"/edit");
        });
      },
      doCurriculumHelp(num) {
        
        var cnt = "";
 
        if (num == 7) {
          cnt = "<p>A training plan consists of lessons, of which there are three different types:</p>";
          cnt +="<p>Simulation: Student will be required to play a simulation from start to finish.<br />E-Learning Only: The student will be required to review e-learning materials for a specific amount of time.<br />Questionnaire: The student will be required to fill out a survey or test.</p>";
        }

        if (num == 8) {
          cnt = "<p>If checked, then the student will be able to access the product in Training Center outside of the curriculum. This will allow the student to practice the simulation outside of the administrator's specifications.</p>";
        }

        if (num == 9) {
          cnt = "<p>If a student stops playing a simulation while in the middle of a training plan the simulation will normally resume where the student left off when the student begins again.</p>";
          cnt += "<p>If this option is checked then the student will restart the simulation instead of resuming.</p>";
        }

        if (num == 10) {
          cnt = "<p>If this option is checked then the student will have the option to play this lesson as many times as they want. The lesson will never be marked as 'completed'.</p>";
          cnt += "<p>Note that your training plan reports will show the training plan as 'incomplete' so long as this option is checked on a lesson within that training plan.</p>";
        }

        if (num == 13) {
          cnt = "<p>If this value is set to higher than zero then the student will be required to review the e-learning materials for this amount of time prior to proceeding.</p>";
          cnt += "<p>Please note that we have no way of preventing the student from doing other things during this time, but they will not be able to proceed until this amount of time has passed.</p>";
        }


        if (num == 15) {
          cnt = "<p>The lesson instructions will appear at the beginning of each lesson. They will also be viewable at any time within the lesson by clicking the question mark icon in the upper right.</p>";
        }

        if (num == 16) {
          cnt = "<p>The lesson completed text will appear at the end of any lesson that the student completes.</p>";
        }

        if (num == 17) {
          cnt = "<p>The lesson not completed text will appear at the end of any lesson that the student has not completed.</p>";
        }

        if (num == 18) {
          cnt = "<p>If selected then the student will be able to skip the audio/video portion of each turn in the simulation.</p>";
        }

        if (num == 19) {
          cnt = "<p>If selected then statements will be color-coded according to how positively or negatively then impact the character.</p>";
        }

        if (num == 20) {
          cnt = "<p>If selected then follow-on statements will be highlighted a separate color from normal statements.</p>";
        }

        if (num == 21) {
          cnt = "<p>If selected then the student will have access to the options panel. This access will not allow them to modify any options which are disallowed by this lesson.</p>";
        }

        if (num == 22) {
          cnt = "<p>If selected then the student will be able to view tool-tip information within the Trainer.</p>";
        }

        if (num == 23) {
          cnt = "<p>If selected then the student will be able to review their final score on the scoring page.</p>";
        }

        if (num == 24) {
          cnt = "<p>If selected then the student will be able to review the introductory materials. This option is *required* for systems that use Levels of Play.</p>";
        }

        if (num == 25) {
          cnt = "<p>This option allows you to force the members to use the Trainer in List Mode or Tabbed Mode. Default allows the student to choose (provided that they have access to Options).</p>";
        }

        if (num == 26) {
          cnt = "<p>If selected then the student will receive feedback for every statement they make and every response the character makes.</p>";
        }

        if (num == 27) {
          cnt = "<p>If selected then the student will see a meter indicating how positively or negatively their last statement impacted the character.</p>";
        }

        if (num == 28) {
          cnt = "<p>If selected then the help coach (SIMmantha) will appear on the screen and provide feedback for every statement.</p>";
        }

        if (num == 29) {
          cnt = "<p>If selected then the student will be able to restart the simulation from within the Trainer.</p>";
        }

        if (num == 30) {
          cnt = "<p>If selected then the student will be able to review and replay their previous turns (transcript).</p>";
        }

        if (num == 31) {
          cnt = "<p>If selected then the student will be able to rewind to a previous turn within the transcript. The student must be able to see the transcript to use this option.</p>";
        }

        if (num == 32) {
          cnt = "<p>You may restrict the student to specific levels of play for this lesson by unchecking the boxes next to the levels that should not be allowed.</p>";
        }

        if (num == 33) {
          cnt = "<p>You may restrict the student to specific characters for this lesson by unchecking the boxes next to the characters that should not be allowed.</p>";
        }

        if (num == 34) {
          cnt = "<p>If there are questionnaires assigned to this license pool then you may select one from the list. Otherwise please contact SIMmersion for more information.</p>";
        }


        if (num == 39) {
          cnt += "<p>If this option is checked then the student will see a countdown clock while they are viewing the e-learning materials.</p>";
        }

        if (num==40) {
          cnt+= "<p>Prompted mode means prompts will appear on the screen to be selected. Off-prompt mode means the trainee will be forced to speak responses to the on-screen character. This choice only applies to products using SIMmersion's latest technology</p>";
        }

        if (num==41) {
          cnt+= "<p>When off-prompt mode is used suggestions will appear on the screen as to what to say. Disable these by leaving this option unchecked. This choice only applies to products using SIMmersion's latest technology</p>";
        }

        this.helpcontent=cnt;
        this.$refs["tpModal"].show();

      },
      fillCharactersLOPs(doSave) {
        if (doSave) {
          this.saveTracker=true;
        }
        var commands = [
            {
              Operation: "Product",
              Function: "GetProductCharacters",
              Fields: {
                ProductID: this.ldata.CourseProductID
              }
            },
             {
               Operation: "Product",
               Function: "GetProductLOPs",
               Fields: {
                 ProductID: this.ldata.CourseProductID
               }
             }

        ];

        if (this.$route.params.lid!==this.emptyguid) {

          commands.push(
          {
            Operation: "LicensePool",
            Function: "GetRestrictedLOPs",
            Fields: {
              LicensePoolCourseID: this.$route.params.lid
            }
          });

          commands.push(
          {
            Operation: "LicensePool",
            Function: "GetRestrictedChars",
            Fields: {
              LicensePoolCourseID: this.$route.params.lid
            }
          });
              
        }

        this.apiCommand(commands).then(r=> {

          var cr = JSON.parse(r.CommandResult);

          var limitcharacters = JSON.parse(cr.returnObjects[0].returnObject);
          var limitlops = JSON.parse(cr.returnObjects[1].returnObject);
          var restrictchars=[];
          var restrictlops=[];


          if (this.$route.params.lid!==this.emptyguid) {
            restrictlops=JSON.parse(cr.returnObjects[2].returnObject);
            restrictchars=JSON.parse(cr.returnObjects[3].returnObject);
          }

          for(var char of limitcharacters) {
            if (restrictchars.indexOf(char.CharacterNum)===-1) {
              char.IsSelected=true;
            }
            else {
              char.IsSelected=false;
            }
          }
          for(var lop of limitlops) {
    
            if (restrictlops.indexOf(lop.LOPAvailable)===-1) {
              lop.IsSelected=true;
            }
            else {
              lop.IsSelected=false;
            }
          }

          this.limitcharacters=limitcharacters;
          this.limitlops=limitlops;


        });
      },
  
      render() {

        var cmds=[
          {
            Operation: "LicensePool",
            Function: "GetProductsForCurricula",
            Fields: { }
          },
          {
            Operation: "LicensePool",
            Function: "GetQuestionnaires",
            Fields: { }
          }
        ]

        if (this.$route.params.lid===this.emptyguid) {
          this.ldata={
            PlayInfinitely: false,
            CourseName: "",
            ShowFeedbackText: true, 
            ShowFeedbackBar:  true,
            ShowHelpAgent: true, 
            AllowOptions:  true,
            AllowRewind:  true,
            AllowRestart:  true, 
            AllowIntroScreens:  true,
            AllowResume:  true,
            AllowTranscript: true,
            AllowAVSkipping:  true,
            AllowScoreReview:  true,
            AllowTooltips:  true,
            HighlightFollowOns: true, 
            AllowToolTips:  true,
            StatementViewType: 0,
            CoursePassedText:  "",
            CourseFailedText:  "",
            CourseInstructions: "",
            CanPractice: false,
            CourseType: 0,
            CourseTime: 0,
            CourseProductID: this.emptyguid,
            StudentCanRestart: false, 
            LessonDescription: "",
            EnableClock: false,
            TimeLimit: 0,
            OffPromptMode: 0,
            OffPromptSuggestions: true
          };
        }
        else {
           
          cmds.push({
            Operation: "LicensePool",
            Function: "GetCourse",
            Fields: {
              LicensePoolCurriculaCourseID: this.$route.params.lid
            }
          });

          cmds.push({
            Operation: "LicensePool",
            Function: "GetCourseCompletionCriteria",
            Fields: {
              LicensePoolCurriculaID: this.$route.params.tpid,
              LicensePoolCurriculaCourseID: this.$route.params.lid
            }
          });
        }

        this.apiCommand(cmds).then(r=>{

          var cr=JSON.parse(r.CommandResult);
          this.Products=JSON.parse(cr.returnObjects[0].returnObject);
          this.Products.unshift({
            ProductID: this.emptyguid,
            ProductName:"--- Select ---"
          });

          this.Questionnaires=JSON.parse(cr.returnObjects[1].returnObject);

          if (this.$route.params.lid!==this.emptyguid) {
            this.ldata=JSON.parse(cr.returnObjects[2].returnObject);
            this.allcc=JSON.parse(cr.returnObjects[3].returnObject);
            for(var cc of this.allcc) {
              cc.IsAdded=false;
              cc.IsEdited=false;
              cc.IsRemoved=false;
            }

            if (this.ldata.CourseType===0) {
              this.fillCharactersLOPs(false);
            }

          }

        });
      },
      goBack() {
        this.$router.back();
      },
      setSaveTracker() {
        this.saveTracker=true;
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapClient(this.udata.ClientID);
        this.render();
      });
    }
  }
</script>
